/* TODO: Referans listesi; YouTube kanalları (görüntülenme bazlı sıralı) ve Spotify
   playlist'i "Produce By Zafer Tufan" içerisinden derlenmiştir. Yeni prodüksiyon
   eklendiğinde bu listeye manuel olarak yeni satır eklenir. */

// YouTube trackleri — canlı çekilmiş görüntülenme sayısına göre yüksekten düşüğe sıralı.
const YOUTUBE_TRACKS = [
  { title: "Acıya Sığınmak", artist: "Ferat Üngür", cover: "https://i.ytimg.com/vi/UN-mv8Nt_Qs/maxresdefault.jpg", views: 1134207 },
  { title: "Geber (Tuğkan Cover)", artist: "Alkan Dalgakıran", cover: "https://i.ytimg.com/vi/waT1_4ZXVEA/maxresdefault.jpg", views: 865254 },
  { title: "Gesi Bağları", artist: "Ferat Üngür", cover: "https://i.ytimg.com/vi/6UuPFogIg2U/maxresdefault.jpg", views: 538739 },
  { title: "Vazgeçme", artist: "Aytaç Şaşmaz", cover: "https://i.ytimg.com/vi/aInrC_zO4eE/maxresdefault.jpg", views: 394533 },
  { title: "Nilüfer", artist: "Alkan Dalgakıran", cover: "https://i.ytimg.com/vi/vvP5bE2GrcU/hqdefault.jpg", views: 156522 },
  { title: "Seni Yazdım Kalbime", artist: "Semih Kandemir", cover: "https://i.ytimg.com/vi/A2aaRD-YfSE/maxresdefault.jpg", views: 54154 },
  { title: "Depresif", artist: "Eren Kırıl", cover: "https://i.ytimg.com/vi/L7SMRX4vaew/maxresdefault.jpg", views: 7250 },
];

// Spotify trackleri — playlist sırası korunur (Spotify açık dinlenme sayısı sağlamıyor).
const SPOTIFY_TRACKS = [
  { title: "Afiş", artist: "Burak Şenöz", cover: "https://i.scdn.co/image/ab67616d0000b273da8cebf50354ea5d4c777fa8" },
  { title: "Yolu Yok", artist: "Aganta", cover: "https://i.scdn.co/image/ab67616d0000b273c5248b58e60b8d4c747f8b36" },
  { title: "Beyaz Elbise", artist: "Aganta", cover: "https://i.scdn.co/image/ab67616d0000b27314218c44ce617f16175bdc2d" },
  { title: "Ben Miyim", artist: "Aganta", cover: "https://i.scdn.co/image/ab67616d0000b273c6fe632545cee28ebab99b8c" },
  { title: "Sıkıntılı", artist: "DENDEN", cover: "https://i.scdn.co/image/ab67616d0000b273983ddda0be8ec9195eb31394" },
  { title: "Altın Semer (Sedd Live) — Rock Version", artist: "İkbal Aferin", cover: "https://i.scdn.co/image/ab67616d0000b273e6e8cd1638ae9780c79aaf9a" },
  { title: "Yan — Live", artist: "İkbal Aferin", cover: "https://i.scdn.co/image/ab67616d0000b273602436e70e1e6c66c1a67924" },
  { title: "O Yar Gelir", artist: "Ferat Üngür, Canref", cover: "https://i.scdn.co/image/ab67616d0000b27361a0f0285f047476ba41f25b" },
  { title: "Dönemez Gururum", artist: "Asil Türkmen", cover: "https://i.scdn.co/image/ab67616d0000b273986dba091f5740d510a08ddb" },
  { title: "Düş Bi' Artık Yakamdan", artist: "Saydam", cover: "https://i.scdn.co/image/ab67616d0000b2735b8da6576d8bb36aa7b7cae8" },
  { title: "Kime Aitsen", artist: "Abdullah Gürtürk", cover: "https://i.scdn.co/image/ab67616d0000b273c5e35ee048dcf117b817fd6f" },
  { title: "Sessiz Çığlık", artist: "Blöf", cover: "https://i.scdn.co/image/ab67616d0000b273444b77a3a271d97a45bed0f7" },
  { title: "Merdo — Rock Version", artist: "Sahibinden", cover: "https://i.scdn.co/image/ab67616d0000b273a5deea4cf9e7100a344c6533" },
  { title: "Son Gece", artist: "Ünsal Eser", cover: "https://i.scdn.co/image/ab67616d0000b273d88cb441d135511ee2630ee5" },
  { title: "Özledim Desem", artist: "Ünsal Eser", cover: "https://i.scdn.co/image/ab67616d0000b2736661250c65692c25481fc817" },
  { title: "Gri Renkler", artist: "Ünsal Eser", cover: "https://i.scdn.co/image/ab67616d0000b2733ef0af9c6e44e0b8c9b0b8e1" },
  { title: "İlan-ı Aşk", artist: "Ünsal Eser", cover: "https://i.scdn.co/image/ab67616d0000b273acca038d72aa98af0c58f3b1" },
  { title: "Sevmek Yeterli Değilmi", artist: "Ünsal Eser", cover: "https://i.scdn.co/image/ab67616d0000b27328c97c9061796fcaf94202ae" },
  { title: "Kuyu", artist: "Ünsal Eser", cover: "https://i.scdn.co/image/ab67616d0000b273cc1de376404c4a8392fbaf5b" },
  { title: "Hayaller Güzeldir", artist: "Ünsal Eser", cover: "https://i.scdn.co/image/ab67616d0000b2732c45690fdb16c026174a37ff" },
  { title: "Dip", artist: "Ünsal Eser", cover: "https://i.scdn.co/image/ab67616d0000b2732ab48fd6755489b2318f4515" },
  { title: "Son Liman", artist: "Ünsal Eser", cover: "https://i.scdn.co/image/ab67616d0000b27333fd9b936312233e60aa2c95" },
  { title: "Dayanamıyorum", artist: "Ünsal Eser", cover: "https://i.scdn.co/image/ab67616d0000b2737d850e328ac273242835430a" },
  { title: "Kim Bunlar", artist: "JoJo FG", cover: "https://i.scdn.co/image/ab67616d0000b273c4cc9db5a5e0aa35fb42b8c5" },
];

// YouTube görüntülenme sayısına göre sıralı YouTube trackleri en başta,
// ardından Spotify trackleri playlist sırasında gelir.
const TRACKS = [...YOUTUBE_TRACKS, ...SPOTIFY_TRACKS];

export default function References() {
  return (
    <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-16" data-testid="references-page">
      <div className="mono-caps mb-3">Referanslarım</div>
      <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-white max-w-3xl">
        Mix &amp; master yaptığım <span className="gradient-text">şarkılar</span>.
      </h1>
      <p className="mt-4 text-slate-400 max-w-2xl">
        Spotify&apos;da ve YouTube&apos;da yayında olan prodüksiyonlarımdan bir seçki.
      </p>

      <div className="mt-12 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 sm:gap-5">
        {TRACKS.map((t, i) => (
          <article key={i} className="group" data-testid={`reference-${i}`}>
            <div className="aspect-square rounded-2xl overflow-hidden bg-black/40 border border-white/5 shadow-lg shadow-black/40 transition-transform duration-300 group-hover:-translate-y-1 group-hover:shadow-cyan-500/10 group-hover:border-cyan-400/40">
              <img
                src={t.cover}
                alt={`${t.title} — ${t.artist}`}
                loading="lazy"
                onLoad={(e) => {
                  const img = e.currentTarget;
                  if (img.naturalWidth > 0 && img.naturalWidth <= 120 && img.src.includes("/maxresdefault.jpg")) {
                    img.src = img.src.replace("/maxresdefault.jpg", "/hqdefault.jpg");
                  }
                }}
                onError={(e) => {
                  const img = e.currentTarget;
                  if (img.src.includes("/maxresdefault.jpg")) {
                    img.src = img.src.replace("/maxresdefault.jpg", "/hqdefault.jpg");
                  } else if (img.src.includes("/hqdefault.jpg")) {
                    img.src = img.src.replace("/hqdefault.jpg", "/sddefault.jpg");
                  }
                }}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="mt-3 px-1">
              <div className="font-display text-white text-sm sm:text-base leading-tight truncate">{t.title}</div>
              <div className="text-xs sm:text-sm text-slate-400 mt-1 truncate">{t.artist}</div>
            </div>
          </article>
        ))}
      </div>
    </main>
  );
}
